import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=ef4c8108"
var script = {}
import style0 from "./menu.vue?vue&type=style&index=0&id=ef4c8108&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports